import React from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { Dispatch } from '@reduxjs/toolkit';

import { Client } from '../../../../interfaces/client/client.interface';

import { RemoveClientAction } from '../../../../actions/client/client.types';
import { ClientActions } from '../../../../actions/client/client.actions';

import { useAppDispatch, useRemoval } from '../../../../hooks';

import { Modal } from '../../../../components/modal/Modal';
import { ModalLayout } from '../../../../components/modal/ModalLayout';
import RemoveModal from '../../../../components/modal/remove/RemoveModal';

const RemoveClientContainer = () => {
  const dispatch: Dispatch<RemoveClientAction> = useAppDispatch();
  const navigate: NavigateFunction = useNavigate();

  const { element, showModal, setShowModal } = useRemoval();

  const onClose = () => setShowModal(false);

  const handleConfirm = (onComplete: () => void) => {
    dispatch(
      ClientActions.removeClient((element as Client).id as number, navigate, () => {
        onComplete();
        onClose();
      })
    );
  };

  return (
    <>
      {showModal && (
        <Modal>
          <ModalLayout onClose={onClose} title="Remove Client">
            <RemoveModal title={(element as Client).name} onConfirm={handleConfirm} />
          </ModalLayout>
        </Modal>
      )}
    </>
  );
};

export default RemoveClientContainer;
